export enum VisibilityTypes {
  ContactInformation = 'contact',
  ProfileFields = 'profile_fields',
  CvResume = 'cv',
  OpenQuestions = 'screening_questions', // legacy name for open questions
  Profile = 'profile',
  Notes = 'notes',
  Attachments = 'attachments',
  Jobs = 'jobs',
  TalentPools = 'talent_pools',
  Questionnaires = 'questionnaires',
}

export enum AccessTypes {
  Notes = 'notes',
  Results = 'results',
  Attachments = 'attachments',
}
